import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

import { ReviewService } from "../../review.service";
import { ChartOptions, ChartType } from "chart.js";
import { Color } from "ng2-charts";
import { ReviewDataCardComponent } from "../review-data-card.component";
import { HttpCommonService, LookupService, AuthService } from "projects/sepidz-web-framework/src/lib/services";
import { PersianService } from "projects/sepidz-web-framework/src/lib/services/persian.service";

@Component({
  selector: "sepidz-chart-review",
  template: `
    <div
      class="card"
      style="padding: 0.8rem ; background: var(--bg-light); color: var(--color-text-dark); height: 100%; font-size:0.8rem; border-radius:10px">
      {{ title }}
      <div class="cardbody">
        <canvas
          baseChart
          height="200"
          [datasets]="datasetList"
          [labels]="labels"
          [options]="chartOptions"
          [colors]="chartColors"
          [legend]="chartLegend"
          [chartType]="chartType"></canvas>
      </div>
    </div>
  `,
})
export class ChartReviewComponent extends ReviewDataCardComponent implements OnChanges {
  @Input() aggregateColumns: string[] = ["data"];
  @Input() keyColumn = "Name";
  @Input() seriesTitle = ["data"];
  @Input() chartColors: Color[] = chartColors;
  @Input() chartLegend = true;
  @Input() chartType: ChartType = "bar";
  @Input() stacked = true;
  @Input() chartOptions: ChartOptions;
  @Input() ratio = 1;
  labels: string[] = [];
  @Input() datasetList: any[] = [];
  @Input() dataList: any[] = [];
  loaded: boolean;

  constructor(
    service: ReviewService,
    fetchService: HttpCommonService,
    protected lookupservice: LookupService,
    private persian: PersianService,
    protected authService: AuthService
  ) {
    super(service, fetchService, lookupservice, authService);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes["dataList"].currentValue) {
      this.retrieved(this.dataList);
    }
  }
  protected retrieved(data: any): void {
    this.labels = [];
    this.datasetList = [];
    if (Array.isArray(data)) {
      for (const dataItem of data) {
        if (this.labels.indexOf(dataItem[this.keyColumn]) === -1) {
          this.labels.push(dataItem[this.keyColumn]);
        }
      }

      for (let i = 0; i < this.aggregateColumns.length; i++) {
        const aggregateColumnTitle = this.seriesTitle[i];
        const dataItems = {
          data: data.map((c) => c[this.aggregateColumns[i]]),
          label: aggregateColumnTitle,
          borderWidth: 0,
        };
        this.datasetList.push(dataItems);
      }
    } else {
      const dataItems = {
        data: {},
        label: "Empty",
        borderWidth: 0,
      };
      this.datasetList.push(dataItems);
    }
  }

  protected initialize(): void {
    this.populateDefaultOption();
  }

  populateDefaultOption(): any {
    this.chartOptions = {
      tooltips: {
        mode: "index",
        intersect: false,
        titleFontFamily: "IRANSansX",
        titleFontStyle: "400",
        titleFontSize: 12,
        bodyFontFamily: "IRANSansX",
        bodyFontSize: 12,
      },
      responsive: true,
      scales: {
        xAxes: [
          {
            gridLines: {
              color: "rgba(0,0,0,0.02)",
              zeroLineColor: "rgba(0,0,0,0.02)",
            },
            stacked: this.stacked,
            ticks: {
              beginAtZero: true,
              fontSize: 11,
              fontFamily: "IRANSansX",
              callback: (label, index, labels) => {
                if (isNaN(label as any)) {
                  return label;
                }
                return this.persian.toPersianNumber(label as any);
              },
            },
          },
        ],
        yAxes: [
          {
            gridLines: {
              color: "rgba(0,0,0,0.02)",
              zeroLineColor: "rgba(0,0,0,0.02)",
            },
            stacked: this.stacked,
            ticks: {
              beginAtZero: false,
              fontSize: 12,
              fontFamily: "IRANSansX",
              callback: (label, index, labels) => {
                if (isNaN(label as any)) {
                  return label;
                }

                if (this.datasetList.every((d) => !d["data"].length)) {
                  return;
                }
                label = (label as number) / this.ratio;
                return this.persian.toPersianNumber(label as any);
              },
            },
          },
        ],
      },
      legend: {
        display: false,
        position: "bottom",
      },
      plugins: {
        labels: {
          render: (args) => "",
        },
      },
    };
  }
}

const chartColors = [
  {
    backgroundColor: "#80CBC4",
    borderColor: "#00897B",
    pointBackgroundColor: "#00897B",
    pointBorderColor: "#fff",
    pointHoverBackgroundColor: "#fff",
    pointHoverBorderColor: "#00897B",
  },
  {
    // dark grey
    backgroundColor: "rgba(77,83,96,0.2)",
    borderColor: "rgba(77,83,96,1)",
    pointBackgroundColor: "rgba(77,83,96,1)",
    pointBorderColor: "#fff",
    pointHoverBackgroundColor: "#fff",
    pointHoverBorderColor: "rgba(77,83,96,1)",
  },
  {
    // red
    backgroundColor: "rgba(255,0,0,0.3)",
    borderColor: "red",
    pointBackgroundColor: "rgba(148,159,177,1)",
    pointBorderColor: "#fff",
    pointHoverBackgroundColor: "#fff",
    pointHoverBorderColor: "rgba(148,159,177,0.8)",
  },
  {
    // grey
    backgroundColor: "rgba(148,159,177,0.2)",
    borderColor: "rgba(148,159,177,1)",
    pointBackgroundColor: "rgba(148,159,177,1)",
    pointBorderColor: "#fff",
    pointHoverBackgroundColor: "#fff",
    pointHoverBorderColor: "rgba(148,159,177,0.8)",
  },
];
